<script>
import TamaraLogo from '@/assets-v4/tamara-logo.svg?url'
import { TRACKING_EVENTS } from '@/constants/tracking'

export default {
  name: 'TamaraFooter',
  props: {
    switchLanguage: Proptypes.boolean(false),
    hideLogo: Proptypes.boolean(false),
  },
  computed: {
    tamaraLogo() {
      return TamaraLogo
    },
  },
  methods: {
    switchLanguageClicked() {
      const localeRoute = this.$t('footer_item_link')
      const queryParams = new URLSearchParams(window.location.search)
      queryParams.set('locale', localeRoute.split('=')[1])
      const locale = localeRoute.split('=')[1]
      const lang = locale.split('-')[0]
      if (lang === 'en') {
        this.trackEvent(
          TRACKING_EVENTS.LOGIN_SWITCH_LANGUAGE_TO_EN_CLICKED.EVENT_NAME
        )
      } else {
        this.trackEvent(
          TRACKING_EVENTS.LOGIN_SWITCH_LANGUAGE_TO_AR_CLICKED.EVENT_NAME
        )
      }
      window.location.href = `${
        window.location.pathname
      }?${queryParams.toString()}`
    },
  },
}
</script>

<template>
  <div class="tamara-base-footer">
    <div class="justify-center w-full mb-4 mb-md-9 d-flex align-center">
      <a
        v-if="switchLanguage"
        class="font-weight-bold text-title-2 link--text text-decoration-none switch-language-button"
        @click="switchLanguageClicked"
      >
        {{ $t('footer_item_label') }}
      </a>
    </div>
    <v-card
      v-if="!hideLogo"
      flat
      width="40px"
      height="40px"
      class="justify-center mx-auto d-flex align-center"
      color="transparent"
    >
      <SvgIcon size="40px" color="#ccc" name="logo-tamara" />
    </v-card>
  </div>
</template>

<style lang="scss" scope>
@import '@/styles/direction.scss';

.tamara-base-footer {
  padding-top: 24px;
  padding-bottom: 48px;

  .switch-language-button {
    font-family: 'IBM Plex Sans Arabic', sans-serif !important;
  }
}

@include for-rtl {
  .tamara-base-footer {
    .switch-language-button {
      font-family: 'Plus Jakarta Sans', sans-serif !important;
    }
  }
}
</style>
